import { SelectOrganization } from '@/components/installFlowV2/select-organization'
import { isAuthenticated } from '@/auth';
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod';

export const Route = createFileRoute('/installFlow/select-organization')({
  component: SelectOrganization,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
  },
  
})

